import * as React from 'react';
import { EGDSLayoutFlex } from '@egds/react-core/layout-flex';
import { ExperienceTemplateRenderer } from 'experience-template-renderer-react';
import { boolean, object, optional, safeParse } from 'valibot';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
export const ListViewLayout = ({
  templateComponent: {
    children,
    config
  }
}) => {
  var _a;
  const configSchema = optional(object({
    reverse: optional(boolean())
  }));
  const result = safeParse(configSchema, config);
  if (!result.success || !children) {
    return null;
  }
  const {
    reverse
  } = (_a = result.output) !== null && _a !== void 0 ? _a : {};
  return React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(EGDSLayoutFlex, {
    direction: reverse ? 'row-reverse' : 'row'
  }, React.createElement(ExperienceTemplateRenderer, {
    templateComponents: children
  }))), React.createElement(ViewSmall, null, React.createElement(EGDSLayoutFlex, {
    direction: "column"
  }, React.createElement(ExperienceTemplateRenderer, {
    templateComponents: children
  }))));
};